import { render, staticRenderFns } from "./CoverPhotos.vue?vue&type=template&id=5ecb3fb9"
import script from "./CoverPhotos.vue?vue&type=script&lang=js"
export * from "./CoverPhotos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports